import reducerRegistry from 'core/lib/store/reducer-registry';
import { HEADER_ISSHOW,HEADER_ISSHOW_SUCCESS,HEADER_ISSHOW_ERROR,
        REQUEST_LOADING,REQUEST_LOADING_SUCCESS,REQUEST_LOADING_ERROR
} from "../action-types/userInfo";
import globalStateReducer from '../reducers/globalState'

reducerRegistry.register('globalState', globalStateReducer)

export function getGlobalState(callback) {
  return {
    types: [HEADER_ISSHOW,HEADER_ISSHOW_SUCCESS,HEADER_ISSHOW_ERROR,
      REQUEST_LOADING,REQUEST_LOADING_SUCCESS,REQUEST_LOADING_ERROR
    ],
    callAPI: () => callback(),
  };
}